import React, { useState } from 'react';
import { Plus, Tag, X } from 'lucide-react';

/** @param {{tags?:string[], onUpdateTags:(id:string,tags:string[])=>void, entryId:string}} props */
export default function TagsManager({ tags, onUpdateTags, entryId }) {
  const [isEditing, setIsEditing] = useState(false);
  const [newTag, setNewTag] = useState('');
  const [currentTags, setCurrentTags] = useState(tags || []);

  const add = () => {
    const t = newTag.trim();
    if (!t || currentTags.includes(t)) return;
    const next = [...currentTags, t];
    setCurrentTags(next);
    onUpdateTags(entryId, next);
    setNewTag('');
  };

  const remove = (t) => {
    const next = currentTags.filter((x) => x !== t);
    setCurrentTags(next);
    onUpdateTags(entryId, next);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 mt-2">
      {currentTags.map((t) => (
        <span key={t} className="inline-flex items-center px-2 py-1 text-xs font-medium bg-blue-100 text-blue-700 rounded-full group hover:bg-blue-200">
          <Tag className="w-3 h-3 mr-1" />
          {t}
          <button onClick={() => remove(t)} className="ml-1 opacity-0 group-hover:opacity-100 text-blue-500 hover:text-blue-700">
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}

      {isEditing ? (
        <div className="flex items-center space-x-1">
          <input
            type="text"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') add(); if (e.key === 'Escape') { setIsEditing(false); setNewTag(''); } }}
            onBlur={() => setIsEditing(false)}
            placeholder="Add tag..."
            className="w-20 px-2 py-1 text-xs border border-slate-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
            autoFocus
          />
          <button onClick={add} className="text-blue-600 hover:text-blue-700" title="Add tag">
            <Plus className="w-3 h-3" />
          </button>
        </div>
      ) : (
        <button
          onClick={() => setIsEditing(true)}
          className="inline-flex items-center px-2 py-1 text-xs text-slate-500 hover:text-slate-700 border border-dashed border-slate-300 rounded-full hover:border-slate-400"
        >
          <Plus className="w-3 h-3 mr-1" />
          Add tag
        </button>
      )}
    </div>
  );
}
